module.exports = __webpack_public_path__ + "img/back.9dbb8a0a.svg";